import React from 'react';
import RowsPerPage from '__common/components/RowsPerPage';
import { connect } from 'react-redux';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { MARK_PROJECT_AS_TEST_ACCESS } from 'user/userGroups';
import {
  SET_DEFAULT_PROJECT_MODE,
  SET_USER_PROJECTS_PER_PAGE,
  SET_USER_PROJECTS_SORTING,
  SET_USER_SORT_METHOD,
} from 'actions';

type Props = {
  dispatch: Function;
  userPreferences: userPreferencesState;
  user: userState;
};

class OtherUserSettings extends React.Component<Props> {
  ROWS_PER_PAGE = [10, 20, 50, 100];
  SORTINGS = [
    { name: 'ASCENDING', value: 1 },
    { name: 'DESCENDING', value: 2 },
  ];
  PROJECTS_SORTINGS = [
    { name: 'PROJECT NAME', value: 1 },
    { name: 'DATE CREATED', value: 2 },
    { name: 'MFG', value: 3 },
    { name: 'MODEL', value: 4 },
    { name: 'CLIENT NAME', value: 5 },
    { name: 'ZIP', value: 7 },
    { name: 'LIST', value: 8 },
  ];
  PROJECT_MODE = [
    { name: 'PRODUCTION', value: 0 },
    { name: 'TEST', value: 1 },
  ];

  setRowsPerPage = (rowsPerPage: number) => {
    const { dispatch } = this.props;
    dispatch(SET_USER_PROJECTS_PER_PAGE(rowsPerPage));
  }

  setProjectsSorting = (projectsSorting: string) => {
    const { dispatch } = this.props;
    dispatch(SET_USER_PROJECTS_SORTING(projectsSorting));
  }

  setSortingMethod = (sortingMethod: string) => {
    const { dispatch } = this.props;
    dispatch(SET_USER_SORT_METHOD(sortingMethod));
  }

  setDefaultProjectMode = (mode: number) => {
    const { dispatch } = this.props;
    dispatch(SET_DEFAULT_PROJECT_MODE(mode));
  }

  render() {
    const {
      userPreferences: {
        projects_per_page,
        project_sorting,
        sort_method,
        default_project_mode,
      },
      user: {
        permissions,
      },
    } = this.props;

    return (
      <div className="other-user-settings">
        <RowsPerPage
          label="Projects per page"
          rowsPerPage={projects_per_page}
          rowsPerPageMenu={this.ROWS_PER_PAGE}
          onChange={this.setRowsPerPage}
        />
        <FormControl fullWidth >
          <InputLabel id="project sorting">PROJECT SORTING</InputLabel>
          <Select
            placeholder="Select project sorting"
            label="PROJECT SORTING"
            labelId="project sorting"
            variant='standard'
            value={project_sorting}
            onChange={(e) => this.setProjectsSorting(String(e.target.value))}
            MenuProps={{
              anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
              transformOrigin: { vertical: 'top', horizontal: 'left' },
            }}
          >
            {this.PROJECTS_SORTINGS.map(item => (
              <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth >
          <InputLabel id="sort method">SORT METHOD</InputLabel>
          <Select
            placeholder="Select sort method"
            label="SORT METHOD"
            labelId="sort method"
            variant='standard'
            value={String(sort_method)}
            onChange={(e) => this.setSortingMethod(String(e.target.value))}
            MenuProps={{
              anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
              transformOrigin: { vertical: 'top', horizontal: 'left' },
            }}
          >
            {this.SORTINGS.map(item => (
              <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        {permissions.includes(MARK_PROJECT_AS_TEST_ACCESS) && (
          <FormControl fullWidth>
            <InputLabel id="default_project_mode">DEFAULT PROJECT MODE</InputLabel>
            <Select
              placeholder="Select default project mode"
              label="DEFAULT PROJECT MODE"
              variant='standard'
              labelId="default_project_mode"
              value={default_project_mode}
              onChange={(e) => this.setDefaultProjectMode(Number(e.target.value))}
              MenuProps={{
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                transformOrigin: { vertical: 'top', horizontal: 'left' },
              }}
            >
              {this.PROJECT_MODE.map(item => (
                <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </div>
    );
  }
}

function mapStateToProps(appState: appState) {
  return {
    userPreferences: appState.userPreferences,
    user: appState.user,
  };
}

export default connect(mapStateToProps)(OtherUserSettings);
